import styled from 'styled-components'
import { TextButton as StormTextButton, Text as StormText, Divider as StormDivider, Link, Button as StormButton, Icon, SecondaryView as StormSecondaryView } from '@amzn/storm-ui'
import { customColor, customBgColor, customFont, customMobilePadding, customMobileMargin } from '../style'
import { MediaContainer as CommonMediaContainer } from '../../../common/components/MediaContainer'

export const SecondaryView = styled(StormSecondaryView)`
  background-color: ${({ theme }) => theme.palette.ccxEmptyGrey};
`

export const SecondaryViewContent = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`

export const SheetContainer = styled.div`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  flex: 1;
`
export const TopBarWrapper = styled.div`
  ${customMobilePadding('small', 'medium', 'small', 'medium')}
  background: rgb(240, 240, 240);
`

export const CloseBtnWrapper = styled(StormTextButton)`
  display: flex;
  ${customColor()}
  ${customFont('medium')}
  &:active,
  &:focus {
    ${customColor()}
    text-decoration: none;
  }
`

export const BackIcon = styled(Icon)`
  ${customMobileMargin('none', 'mini', 'none', 'none')}
`

export const HeaderWrapper = styled.div`
  ${customMobilePadding('base', 'base', 'base', 'base')}
  ${customBgColor('inkwell')}
  ${customColor('white')}
  display: flex;
  justify-content: space-between;
`
export const ListBtnText = styled(StormTextButton)`
  align-self: center;
  ${customColor('white')}
  &:active,
  &:focus {
    text-decoration: none;
    ${customColor('white')}
  }
`
export const ListContainer = styled.div`
  ${customMobilePadding('none', 'base', 'small', 'base')}
  display: flex;
  flex-direction: column;
  flex: auto;
  background: ${({ theme }) => theme.palette.ccxEmptyGrey};
`

export const ProductAnnouncementContainer = styled.div`
  padding-top: ${({ theme }) => theme.spacing.xlarge};
  padding-left: 6px;
  margin-top: auto;
`

export const DateText = styled(StormText)`
  line-height: 18px;
  color: ${({ theme }) => theme.palette.ccxTextGreyOne};
  ${customMobileMargin('small', 'none', 'small', 'none')}
`

export const ListText = styled(StormTextButton)<{ active: boolean }>`
  ${customMobilePadding('small', 'small', 'small', 'small')}
  font-size: 18px;
  line-height: 23px;
  ${customColor()}
  text-align: left;
  border: unset;
  width: 100%;
  background: ${({ active, theme }) => (active ? theme.palette.ccxToggleWhite : `unset`)};
  font-weight: normal;
  &:hover,
  &:active,
  &:focus {
    text-decoration: none;
    ${customColor()}
    background: ${({ theme }) => theme.palette.ccxToggleWhite};
  }
`
export const Divider = styled(StormDivider)`
  ${customMobileMargin('none', 'none', 'none', 'none')}
`
export const ContentHeaderContainer = styled.div`
  display: flex;
  padding: ${({ theme }) => theme.mobile.spacing.medium} ${({ theme }) => theme.mobile.spacing.medium} ${({ theme }) => theme.mobile.spacing.medium}
    ${({ theme }) => theme.mobile.spacingValues.base + 6}px;
  background: rgb(250, 250, 251);
`

export const ContentContainer = styled.div`
  ${customMobilePadding('base', 'base', 'large', 'base')}
  background: rgb(250, 250, 251);
  flex: auto;
`

export const TextBodyContainer = styled.div`
  padding: 0 6px;
`
export const IngressLink = styled(Link)`
  font-family: 'Amazon Ember', Helvetica, sans-serif;
  &&& {
    color: rgb(0, 102, 192);
  }
  display: block;
  ${customMobileMargin('medium', 'none', 'none', 'none')}
`
export const Button = styled(StormButton)`
  ${customMobileMargin('small', 'none', 'none', 'none')}
  line-height: 1;
  display: block;
`
export const ContentMenuContainer = styled.div`
  ${customMobilePadding('small', 'base', 'small', 'base')}
  display: flex;
  background: ${({ theme }) => theme.palette.ccxEmptyGrey};
  justify-content: space-evenly;
  min-height: 62px;
`

export const ContentMenuItemContainer = styled(StormTextButton)`
  text-align: left;
  align-self: start;
  flex: 1;
  text-decoration: none;
  &:active,
  &:hover {
    text-decoration: none;
  }
`

export const VerticalDivider = styled.div`
  position: relative;
  border-left-width: 1px;
  /* Makes the border remain 1px in size at any zoom */
  border-left-width: thin;
  border-left-style: solid;
  border-left-color: ${({ theme }) => theme.palette.ccxDividerGrey};
  margin: 0 ${({ theme }) => theme.divider.margin};
`
export const StickyHeaderWrapper = styled.div`
  position: fixed;
  width: 100%;
  z-index: 398;
`

export const DotIcon = styled(Icon)`
  color: rgb(1, 132, 133);
  padding-right: 10px;
  font-size: 6px;
  align-self: center;
`

export const DotBtnIcon = styled(Icon)`
  color: rgb(1, 132, 133);
  padding-right: 6px;
  font-size: 6px;
  vertical-align: middle;
`

export const ListItemsWrapper = styled.div`
  display: flex;
`

export const MediaContainer = styled(CommonMediaContainer)`
  margin-bottom: ${({ theme }) => theme.mobile.spacing.medium};
`
